import styled from 'styled-components'

export const RentContractListWrap = styled.div`
  display: block;
  width: 100%;
  overflow: auto;
`
